/** A URL is an import reference, never a durable image identity. */
export function imageUrl(value: unknown): string | undefined {
  if (typeof value !== "string") return;
  const text = value.trim();
  if (!/^https?:\/\//i.test(text)) return;
  try {
    const url = new URL(text);
    if (
      text.length > 2048 ||
      url.href.length > 2048 ||
      /[\u0000-\u0020\u007f]/.test(text) ||
      url.username ||
      url.password ||
      url.hash ||
      !url.hostname
    )
      return;
    return url.href;
  } catch {
    return;
  }
}
